export const CORE_APP_UPDATE_PREVIOUS_ROUTE = 'CORE_APP:UPDATE_PREVIOUS_ROUTE';

export const updatePreviousRoute = (route) => async (dispatch) => {
    dispatch({
        type: CORE_APP_UPDATE_PREVIOUS_ROUTE,
        data: route,
    });
};
